import { useEffect, useState } from 'react';

export type ThemeName = 'classic' | 'midnight' | 'bubblegum' | 'swamp';
export type MascotName = 'classic' | 'pixel' | 'geo' | 'outline';

export const THEMES: Record<ThemeName, string> = {
  classic: 'Classic Bath',
  midnight: 'Midnight Pond',
  bubblegum: 'Bubblegum',
  swamp: 'Swamp',
};

const STORAGE_THEME = 'rdd.theme';
const STORAGE_MASCOT = 'rdd.mascot';

function readStored<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  if (typeof window === 'undefined') return fallback;
  const v = window.localStorage.getItem(key);
  return allowed.includes(v as T) ? (v as T) : fallback;
}

export function useTheme(): {
  theme: ThemeName;
  mascot: MascotName;
  setTheme: (t: ThemeName) => void;
  setMascot: (m: MascotName) => void;
} {
  const [theme, setThemeState] = useState<ThemeName>(() =>
    readStored<ThemeName>(STORAGE_THEME, ['classic', 'midnight', 'bubblegum', 'swamp'], 'classic'),
  );
  const [mascot, setMascotState] = useState<MascotName>(() =>
    readStored<MascotName>(STORAGE_MASCOT, ['classic', 'pixel', 'geo', 'outline'], 'classic'),
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    window.localStorage.setItem(STORAGE_THEME, theme);
  }, [theme]);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_MASCOT, mascot);
  }, [mascot]);

  return { theme, mascot, setTheme: setThemeState, setMascot: setMascotState };
}
